<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate select-menu-product-modal" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ tt('common_select', '選擇') }}{{ tt('product_menu', '菜單') }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="d-flex mx-0 mt-2 justify-content-between">
        <nb-select class="col-auto pr-0 ml-auto menu-select" [(ngModel)]="selectPRDMenuNo" (selectedChange)="onQuery()">
          <nb-option *ngFor="let item of titleList" [value]="item.value">
            {{ item.label }}
          </nb-option>
        </nb-select>
      </div>

      <div class="mt-3 table-wrap">
        <table class="table table-bordered table-striped align-middle">
          <thead>
            <tr>
              <th>{{ tt('product_menu_category', '菜單分類') }}</th>
              <th>{{ tt('product_menu', '菜單') }}</th>
              <th class="enable-col">{{ tt('common_enable', '啟用') }}</th>
              <th class="action-col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="mainDataList && mainDataList.length">
              <td><b class="text-info">{{ tt('common_select_all', '選擇全部') }}</b></td>
              <td></td>
              <td class="enable-col">
                <nb-toggle status="info" [(checked)]="status.isSelectAll" (checkedChange)="onSelectAllG()"></nb-toggle>
              </td>
              <td class="action-col">
                <b class="text-info selected-count">{{ getSelectedCountText(status.AllSelectCount) }}</b>
              </td>
            </tr>
            <ng-container *ngFor="let e of mainDataList">
              <tr>
                <td>{{ e.GroupName }}</td>
                <td class="menu-title">{{ e.Title }}</td>
                <td class="enable-col">
                  <nb-toggle status="info" [(checked)]="e.IsOK_Group" (checkedChange)="onSelectG(e.PRDMenuProductGroupNo)"></nb-toggle>
                </td>
                <td class="action-col">
                  <button nbButton class="m-0 w-100 action-btn" (click)="onOpenPd(e.PRDMenuProductGroupNo)">
                    {{ getGroupActionText(e) }}
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePdG();">{{ tt('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ tt('common_close', '關閉') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #PdModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate select-menu-product-modal detail-modal">
    <nb-card-header>
      {{ tt('common_select', '選擇') }}{{ tt('common_product_name', '商品名稱') }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="mt-3 table-wrap">
        <table class="table table-bordered table-striped align-middle">
          <thead>
            <tr>
              <th>{{ tt('common_product_name', '商品名稱') }}</th>
              <th class="enable-col">{{ tt('common_enable', '啟用') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of showListPd">
              <tr>
                <td>{{ e.ProductName }}</td>
                <td class="enable-col">
                  <nb-toggle status="info" class="" [(checked)]="e.IsOK_Product" [disabled]="e.IsCanSelect == 0"></nb-toggle>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePd();">{{ tt('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ tt('common_close', '關閉') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
